import type { CreatorHome } from './types';

// The programme's terms, the same for every creator: what followers save with
// a code and what the creator earns per booking. The creators API doesn't send
// them, so Home shows these fixed values.
export const PROGRAMME_TERMS: Pick<CreatorHome, 'offer' | 'rates'> = {
	offer: {
		discountPercent: 10,
		maxDiscount: { flights: 1000, hotels: 3000 },
	},
	rates: {
		flights: { percent: 2, capPerBooking: 500 },
		hotels: { percent: 4, capPerBooking: 500 },
	},
};
